import { useLocation, useParams } from "react-router-dom";
import { routes } from "../router/mobile/routes";
import { TMobileRouterPath } from "./router";

export const useResolveToBasePath = () => {
  const location = useLocation();
  const params = useParams();
  let route = location.pathname;
  Object.entries(params).forEach(([k, v = ""]) => {
    route = route.replace(v, `:${k}`);
  });
  const profileBase = routes.patientProfile.path;
  if (route === profileBase || route.startsWith(`${profileBase}/`)) {
    return profileBase as TMobileRouterPath;
  }
  return route as TMobileRouterPath;
};
